export default {
	"pages": {
		"root": {
			"id": "root",
			"pageUrl": "root",
			"name": "root",
			"children": [
				"612510d129a0a1001e6c580c",
				"612510d129a0a1001e6c580e"
			]
		},
		"612510d129a0a1001e6c580c": {
			"id": "612510d129a0a1001e6c580c",
			"name": "404",
			"pageUrl": "404"
		},
		"612510d129a0a1001e6c580e": {
			"id": "612510d129a0a1001e6c580e",
			"name": "index",
			"pageUrl": "index"
		}
	},
	"mode": "production",
	"projectType": "create-react-app",
	"site": {
		"styles": {},
		"seo": {}
	}
}